import { Component } from '@angular/core';

@Component({
    selector: 'bb-avatar-page-ui',
    template: '',
    standalone: false,
})
export class AvatarPageComponent {}
